import { render } from "./CommandCommunicationView.vue?vue&type=template&id=5642ae31"
import script from "./CommandCommunicationView.vue?vue&type=script&lang=js"
export * from "./CommandCommunicationView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\r-shibata\\Documents\\multi-point-measurements\\env-unevenness-visualizer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__